import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface User {
  id: number | null;
  username: string;
  password: string;
  email: string;
  roles: string[];
}

export type CreateUserRequest = Omit<User, 'id'>;
export type UpdateUserRequest = Omit<User, 'id'>;

@Injectable({ providedIn: 'root' })
export class UserService {
  private http = inject(HttpClient);
  private usersApi = environment.endpoints.users;

  list(): Observable<User[]> {
    return this.http.get<User[]>(this.usersApi);
  }

  create(user: CreateUserRequest): Observable<User> {
    return this.http.post<User>(this.usersApi, user);
    // Backend example:
    // @PostMapping("/users") -> returns created User
  }

  update(id: number, user: UpdateUserRequest): Observable<User> {
    return this.http.put<User>(`${this.usersApi}/${id}`, user);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.usersApi}/${id}`);
  }
}
